import { RatingWorkplaceParams } from '../../types/Rating/RatingTypes';
import { formatWorkplaceNumber } from './parseRatingParams';

const STORAGE_PREFIX = 'rating-dismissed-session';

const buildStorageKey = (workplace: RatingWorkplaceParams): string =>
  `${STORAGE_PREFIX}:${workplace.branch}:${workplace.queue}:${formatWorkplaceNumber(workplace.cabinet)}:${formatWorkplaceNumber(workplace.window)}`;

export const readDismissedRatingSessionKey = (
  workplace: RatingWorkplaceParams,
): string | null => {
  try {
    return sessionStorage.getItem(buildStorageKey(workplace));
  } catch {
    return null;
  }
};

export const writeDismissedRatingSessionKey = (
  workplace: RatingWorkplaceParams,
  sessionKey: string,
): void => {
  try {
    sessionStorage.setItem(buildStorageKey(workplace), sessionKey);
  } catch {
    // sessionStorage may be unavailable in restricted contexts
  }
};

export const clearDismissedRatingSessionKey = (
  workplace: RatingWorkplaceParams,
): void => {
  try {
    sessionStorage.removeItem(buildStorageKey(workplace));
  } catch {
    // sessionStorage may be unavailable in restricted contexts
  }
};
